import * as React from "react"

// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"
import PageWrapper from "./src/components/page-wrapper"
import { track } from "./src/lib/analytics"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

export const onRouteUpdate = () => {
  requestAnimationFrame(() => window.scrollTo(0, 0))
  track("PageView")
}

export const wrapPageElement = ({ element, props }) => {
  return <PageWrapper location={props.location}>{element}</PageWrapper>
}
